export const usePrefooterPath = (
  locale: string,
  translations?: Array<{ langcode: string; path: string }>,
): string | undefined =>
  translations?.find((it) => it.langcode === locale)?.path;
